import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus } from "@fortawesome/free-solid-svg-icons";

const iconMinus = <FontAwesomeIcon icon={faMinus} color="#e00000" size="sm" />;

export default iconMinus;
